import { Fragment, createRef, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from 'yup';
// import ProfileInfo from "./ProfileInfo";;
import { Link } from "react-router-dom";
import 'react-phone-input-2/lib/style.css'
import PhoneInput from 'react-phone-input-2'
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from "react-redux";
import ProfileInfo from "./Profileinfo";
import React from "react";
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { AdminDetailProfileAction, AdminUpdateProfileAction } from "../../Redux/Action/AuthAction";
import Spinner from "../FieldComponets/Spinner";
import InputField from "../FieldComponets/inputField";
import { ImageUrl, countryCodeValue, imageExtentionSupport } from "../../utils/Helper";
import ActionButton from "../FieldComponets/ActionButton";
import ToastDefault from "../FieldComponets/Toast";
import { url } from "../../Config/Config";
import { toast  } from "react-toastify";
import "cropperjs/dist/cropper.css";
import CropperImage from "../../utils/CropperImage";
import { FormattedMessage, useIntl } from "react-intl";

const minCroppedWidth = 200;
const minCroppedHeight = 200;
const maxCroppedWidth = 200;
const maxCroppedHeight = 200;


function EditProfile() {
  const [image, setImage] = useState("");
  const dispatch = useDispatch<any>();
  const intl = useIntl();
  const DetailAdminProfile = useSelector((state: any) => state.DetailAdminProfileState);

  const UpdateAdminProfile = useSelector((state: any) => state.UpdateAdminProfileState);
  const [showImageIcon, setShowImageIcon] = useState('');

  const formSchema = Yup.object().shape({
    email: Yup.string()
      .email()
      .required(VALIDATION_MESSAGE?.ANY_REQUIRED + " Email")
      .trim(VALIDATION_MESSAGE?.ANY_REQUIRED + " Email")
      .max(50),


    name: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_first_name" }))
      .trim()
      .matches(/^[A-Za-z'\-]+(?: [A-Za-z'\-]+)*$/, intl.formatMessage({ id: "alphabets_hyphen_space_valid" }))
      .min(2, intl.formatMessage({ id: "first_name_min_length" }))
      .max(50, intl.formatMessage({ id: "first_name_max_length" })),

    // lname: Yup.string()
    //   .nullable()
    //   .trim()
    //   .matches(/^(?:[A-Za-z'\-]+(?: [A-Za-z'\-]+)*)?$/, 'Alphabets, hyphen and single space are valid')
    //   .max(50, "Last name" + VALIDATION_MESSAGE?.FULL_NAME_MAX),


    profile: Yup.mixed()
      .test("fileType", VALIDATION_MESSAGE?.USER_UNSUPPORTED, (file: any) => {
        if (file?.length > 0) {
          var file_type = file?.length && ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(file[0].type.toLowerCase())

          if (file_type) {
            return file_type;
          }
          else {
            return file_type;
          }
        }
        else {
          return true;
        }
      })

  });


  useEffect(() => {
    dispatch(AdminDetailProfileAction({}))
  }, [])

  // setError('name', { type: "manual", message: "" })



  const {
    register,
    handleSubmit,
    resetField,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: {
      profile: "",
      name: "",
      // lname: "",
      email: "",
      // phone_country_code: "",
      // phone_number: ""
    }
  });



  const onSubmit = async (payload: any) => {
    payload.profile = dataImage
    await dispatch(AdminUpdateProfileAction(payload));
    setValue("profile", "")
    console.log("Profile Updated Successfully")
    // toast.success("Profile Updated Successfully")
  };



  function capitalizeFirstLetter(str: string): string {
    if (!str) return ''; // Check if str is undefined or null
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }


  useEffect(() => {
    if (DetailAdminProfile) {
      setValue("name", capitalizeFirstLetter(DetailAdminProfile?.data?.data?.name))
      // setValue("lname", capitalizeFirstLetter(DetailAdminProfile?.data?.data?.lname));
      setValue("email", DetailAdminProfile?.data?.data?.email);
      setError('name', { type: "manual", message: "" })
    }
  }, [dispatch, DetailAdminProfile?.data]);


  useEffect(() => {
    if (UpdateAdminProfile && UpdateAdminProfile?.status == true) {
      dispatch(AdminUpdateProfileAction('RESET'));
      resetField('profile');
      dispatch(AdminDetailProfileAction({}))
      setShowImageIcon('')
    }
  }, [dispatch, UpdateAdminProfile])

  const [dataImage, setDataImage]: any = useState("")


  const getCropData = (croppedImageURL: any, newfile: any) => {
    setShowImageIcon(croppedImageURL);
    setImage("")
    setDataImage(newfile)

    // setValue("profile", newfile);
  };

  const cancelCropData = () => {
    setImage("")
    $("#profileImageData").val('')
  }


  const selectFileHandler = (e: any) => {
    console.log(e?.target?.files[0])
    const getextention = e?.target?.files[0]?.name.split('.').pop()
    if (imageExtentionSupport.includes(getextention)) {
      e.preventDefault();
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result as any);
      };
      reader.readAsDataURL(files[0]);
    } else {
      console.log("errrrrr")
      e.preventDefault();
      setValue("profile", "")
      setShowImageIcon("")
      setImage("")
      setDataImage('')
      toast.error(intl.formatMessage({ id: "please_upload_valid_image" })); 
      return;
    }
  };



  return (
    <Fragment>
      {UpdateAdminProfile?.loading ? <Spinner /> : ""}
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">

            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18"><FormattedMessage id="my_profile" /></h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item active"><Link to={url + "/dashboard"}><FormattedMessage id="dashboard" /></Link></li>
                      <li className="breadcrumb-item active"><FormattedMessage id="my_profile" /></li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <ProfileInfo />
              <div className="col-xl-8">
                <div className="card">
                  <div className="card-body">
                    <div className="">
                      <h4 className="page-title"><FormattedMessage id="profile" /></h4>
                      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">

                          <div className="row">
                            <div className="form-group col-md-8 col-lg-6">
                              <label htmlFor="name"><FormattedMessage id="name" /><span>*</span></label>
                              <InputField
                                type="text"
                                className="form-control"
                                id="name"
                                placeholder={intl.formatMessage({ id: "first_name" })}
                                minLength={1}
                                maxLength={50}
                                register={register('name')}

                              />
                              <p className="text-danger">{errors?.name?.message ?? UpdateAdminProfile?.errors?.name?.message}</p>
                            </div>

                          </div>
                          {/* <div className="row">
                            <div className="form-group col-md-8 col-lg-6">
                              <label htmlFor="lname">Last Name</label>
                              <InputField
                                type="text"
                                className="form-control"
                                id="lname"
                                placeholder="Last Name"
                                minLength={1}
                                maxLength={50}
                                register={register('lname')}
                              />
                              <p className="text-danger">{errors?.lname?.message ? errors?.lname?.message : UpdateAdminProfile?.errors ? UpdateAdminProfile?.errors?.lname?.message : ''}</p>
                            </div>
                          </div> */}
                          <div className="row">
                            <div className="form-group col-md-8 col-lg-6">
                              <label htmlFor="name"><FormattedMessage id="profile_picture_label" /> <small><FormattedMessage id="image_type_webp_dimension" /></small></label>
                              <div className="upload-image-back">
                                <InputField
                                  id="profileImageData"
                                  type="file"
                                  accept="image/jpeg,image/png,image/webp"
                                  className="form-control"
                                  register={register('profile')}
                                  onChange={(e: any) => selectFileHandler(e)}
                                />
                              </div>
                              <p className="text-danger">{errors?.profile?.message ?? DetailAdminProfile?.errors?.profile_pic?.message}</p>

                            </div>
                            <div className="col-lg-4 mt-3">
                              {showImageIcon ? (
                                <img
                                  className="border-dark icon a-banner-image-sq"
                                  id="imageProfile"
                                  width="150"
                                  height="70"
                                  src={ImageUrl(showImageIcon)}
                                  alt=""
                                />
                              ) : (
                                DetailAdminProfile?.data?.data?.profile_pic && (
                                  <img
                                    className="border-dark icon a-banner-image-sq"
                                    width="150"

                                    height="70"
                                    src={ImageUrl(DetailAdminProfile?.data?.data?.profile_pic)}
                                    alt=""
                                  />
                                )
                              )}
                            </div>
                          </div>
                          <div className="mt-3">
                            {/* {UpdateAdminProfile.loading ? <ButtonSpinner /> : */}
                            <ActionButton className="btn btn-primary float-start" type="submit" text={intl.formatMessage({ id: "update" })} />
                            {/* <button type="submit" className="btn btn-primary">Update</button> */}

                            {/* } */}
                          </div>
                        


                      </form>
                      {image != "" ?

                        // minCroppedWidth={200}
                        <CropperImage
                          // minCroppedHeight={200}
                          // maxCroppedWidth={200}
                          // maxCroppedHeight={200}
                          image={image}
                          getCropFunction={(croppedImageURL: any, newfile: any) => getCropData(croppedImageURL, newfile)}
                          cancelCropData={() => { cancelCropData() }}
                          zoomTo={0.5}
                          initialAspectRatio={1}
                          aspectRatio={1}
                          viewMode={1}
                          background={false}
                          responsive={true}
                          autoCropArea={1}
                          checkOrientation={false}
                          guides={true}
                        />

                        : ""}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* 
      {image != "" ?

        <CropperImage
          // minCroppedWidth={200}
          // minCroppedHeight={200}
          // maxCroppedWidth={200}
          // maxCroppedHeight={200}
          image={image}
          getCropFunction={(croppedImageURL: any, newfile: any) => getCropData(croppedImageURL, newfile)}
          cancelCropData={() => { cancelCropData() }}
          zoomTo={0.5}
          initialAspectRatio={1}
          aspectRatio={1}
          viewMode={1}
          background={false}
          responsive={true}
          autoCropArea={1}
          checkOrientation={false}
          guides={true}
        />

        : ""} */}
      {/* <ToastDefault /> */}
      {/* <ToastDefault/> */}
    </Fragment>
  );
}

export default EditProfile;

